"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = require("../../Icons");

var _excluded = ["ariaLabel", "classes", "clickMethod", "customIcon", "dataTestId", "href", "icon", "iconPosition", "id", "isFullWidth", "isReversed", "size", "target", "text", "variant"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// I WANT TO MAKE THIS AUTOMATIC!
// If we make a new icon, we have to update this
var IconList = {
  IconAlertCircle: _Icons.IconAlertCircle,
  IconCalendar: _Icons.IconCalendar,
  IconChatBubble: _Icons.IconChatBubble,
  IconChevronRight: _Icons.IconChevronRight,
  IconChevronLeft: _Icons.IconChevronLeft,
  IconChevronDown: _Icons.IconChevronDown,
  IconChevronDoubleDown: _Icons.IconChevronDoubleDown,
  IconClock: _Icons.IconClock,
  IconClose: _Icons.IconClose,
  IconDocument: _Icons.IconDocument,
  IconHelpCircle: _Icons.IconHelpCircle,
  IconInfoShield: _Icons.IconInfoShield,
  IconPhone: _Icons.IconPhone,
  IconPlusCircle: _Icons.IconPlusCircle,
  IconScreenShare: _Icons.IconScreenShare
};
var Link = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      classes = _ref.classes,
      clickMethod = _ref.clickMethod,
      customIcon = _ref.customIcon,
      dataTestId = _ref.dataTestId,
      href = _ref.href,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      id = _ref.id,
      isFullWidth = _ref.isFullWidth,
      isReversed = _ref.isReversed,
      size = _ref.size,
      target = _ref.target,
      text = _ref.text,
      variant = _ref.variant,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var CTAIcon;
  var hasIcon = icon || customIcon;
  if (icon) CTAIcon = IconList[icon];
  if (customIcon) CTAIcon = customIcon;
  var ariaLabelString = '';

  if (ariaLabel && target === '_blank') {
    ariaLabelString = "".concat(ariaLabel, " (opens in a new tab)");
  } else if (!ariaLabel && target === '_blank') {
    ariaLabelString = "".concat(text, " (opens in a new tab)");
  } else {
    ariaLabelString = ariaLabel;
  }

  return /*#__PURE__*/_react.default.createElement("a", _extends({
    id: id || dataTestId,
    className: (0, _classnames.default)('cta', "cta--".concat(variant), "cta--".concat(size), {
      'cta--is-reversed': isReversed,
      'cta--full-width': isFullWidth,
      'cta--icon-only': !text
    }, classes),
    "data-testid": dataTestId,
    href: href,
    target: target,
    rel: target === '_blank' ? 'noopener noreferrer' : null,
    "aria-label": ariaLabelString,
    onClick: clickMethod,
    ref: ref
  }, additionalProps), hasIcon && iconPosition === 'left' && /*#__PURE__*/_react.default.createElement("div", {
    className: "cta__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(CTAIcon, null)), text && /*#__PURE__*/_react.default.createElement("span", {
    className: "cta__label"
  }, text), hasIcon && iconPosition === 'right' && /*#__PURE__*/_react.default.createElement("div", {
    className: "cta__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(CTAIcon, null)));
});
Link.displayName = 'Link';
Link.propTypes = {
  /**
   Required if the contents of the link is only an icon with no text. Sets the `aria-label` attribute for the link used by screen readers. Defaults to `null`.
   */
  ariaLabel: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    return props.text === '';
  }),

  /**
   Optional. String to add custom class(es) to the link.
   */
  classes: _propTypes.default.string,

  /**
   Optional. The function passed to the `onClick` method for the link. Used if some JavaScript function must be called prior to taking the user to the target URL.
   */
  clickMethod: _propTypes.default.func,

  /**
   Optional. Custom SVG icon passed as a React component. Overrides any `icon` prop passed to the link. Defaults to `null`.
   */
  customIcon: _propTypes.default.elementType,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Required. The URL passed to the `href` attribute of the link.
   */
  href: _propTypes.default.string.isRequired,

  /**
   Optional. Icon displayed within the link.
   */
  icon: _propTypes.default.oneOf(Object.keys(IconList)),

  /**
   Optional. Determines whether the icon is placed on the left or right of the text. Defaults to `'left'`.
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   Optional. A unique identifier passed to the element's `id` attribute. Defaults to `null`.
   */
  id: _propTypes.default.string,

  /**
   Optional. Gives the link a width of 100% of it's container. Defaults to `false`.
   */
  isFullWidth: _propTypes.default.bool,

  /**
   Optional. Shows the reversed variant of the CTA for use on dark backgrounds. Defaults to `false`.
   */
  isReversed: _propTypes.default.bool,

  /**
   Optional. Sets the size of the link and it's text. Options: `xlarge` (body1), `large` (body2), `medium` (body3), `small` (body4). Defaults to `'large'`.
   */
  size: _propTypes.default.oneOf(['xlarge', 'large', 'medium', 'small']),

  /**
   Optional. Changes browser window behavior for href. Options: '_blank', '_parent', '_self', '_top'. Defaults to `null`.
   */
  target: _propTypes.default.oneOf(['_blank', '_parent', '_self', '_top']),

  /**
   Optional. The text that is displayed inside the link. Required if no icon is passed to the component. Defaults to `null`.
   */
  text: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    return props.icon === null;
  }),

  /**
   Optional. Sets the visual style for the link. Defaults to `'primary'`.
   */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'alternate', 'critical', 'text-primary', 'text-secondary', 'text-alternate', 'text-critical'])
};
Link.defaultProps = {
  ariaLabel: null,
  classes: '',
  clickMethod: null,
  customIcon: null,
  dataTestId: null,
  icon: null,
  iconPosition: 'left',
  id: null,
  target: null,
  isFullWidth: false,
  isReversed: false,
  variant: 'text-primary',
  size: 'large',
  text: null
};
var _default = Link;
exports.default = _default;